<template>
  <v-expansion-panels>
    <v-expansion-panel :key="0">
      <v-expansion-panel-header expand-icon="arrow_right">
        Tablero Dinámico
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-for="checkbox in checklist">
          <template v-if="isDynamicBoard(checkbox)">
            <v-checkbox
              class="ma-0"
              hide-details
              :key="checkbox.id"
              v-model="checkbox.value"
              :label="checkbox.title"
            ></v-checkbox>
          </template>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel :key="1">
      <v-expansion-panel-header expand-icon="arrow_right">
        Inspección de Daños
      </v-expansion-panel-header>
      <v-expansion-panel-content class="text-left">
        <p class="ma-0 mt-2 font-weight-medium">Consultar</p>
        <template v-for="checkbox in checklist">
          <template v-if="isDamage(checkbox, 'read')">
            <v-checkbox
              class="ma-0"
              hide-details
              :disabled="checkbox.title == 'general'"
              :key="checkbox.id"
              v-model="checkbox.value"
              :label="checkbox.title"
            ></v-checkbox>
          </template>
        </template>
        <p class="ma-0 mt-2 font-weight-medium">Editar</p>
        <template v-for="checkbox in checklist">
          <template v-if="isDamage(checkbox, 'edit')">
            <v-checkbox
              class="ma-0"
              hide-details
              :key="checkbox.id"
              v-model="checkbox.value"
              :label="checkbox.title"
            ></v-checkbox>
          </template>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel :key="2">
      <v-expansion-panel-header expand-icon="arrow_right">
        Indicadores
      </v-expansion-panel-header>
      <v-expansion-panel-content class="text-left">
        <p class="ma-0 font-weight-medium">Sucursal</p>
        <template v-for="checkbox in checklist">
          <template v-if="isIndicators(checkbox, 'sucursal')">
            <v-checkbox
              class="ma-0"
              hide-details
              :key="checkbox.id"
              v-model="checkbox.value"
              :label="checkbox.title"
            ></v-checkbox>
          </template>
        </template>
        <p class="ma-0 mt-2 font-weight-medium">Tipo de Indicador</p>
        <div class="ml-4">
          <p class="ma-0 mb-1">Junta Semanal</p>
          <template v-for="checkbox in checklist">
            <template v-if="isIndicators(checkbox, 'weekly-meeting')">
              <v-checkbox
                class="ma-0"
                hide-details
                :key="checkbox.id"
                v-model="checkbox.value"
                :label="checkbox.title"
              ></v-checkbox>
            </template>
          </template>
          <p class="ma-0 mb-1 mt-2">General</p>
          <template v-for="checkbox in checklist">
            <template v-if="isIndicators(checkbox, 'general')">
              <v-checkbox
                class="ma-0"
                hide-details
                :key="checkbox.id"
                v-model="checkbox.value"
                :label="checkbox.title"
              ></v-checkbox>
            </template>
          </template>
          <p class="ma-0 mb-1 mt-2">Operaciones</p>
          <template v-for="checkbox in checklist">
            <template v-if="isIndicators(checkbox, 'operations')">
              <v-checkbox
                class="ma-0"
                hide-details
                :key="checkbox.id"
                v-model="checkbox.value"
                :label="checkbox.title"
              ></v-checkbox>
            </template>
          </template>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel :key="3">
      <v-expansion-panel-header expand-icon="arrow_right">
        Usuarios y Permisos
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-for="checkbox in checklist">
          <template v-if="isCreateUsers(checkbox)">
            <v-checkbox
              class="ma-0"
              hide-details
              :key="checkbox.id"
              v-model="checkbox.value"
              :label="checkbox.title"
            ></v-checkbox>
          </template>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel :key="4">
      <v-expansion-panel-header expand-icon="arrow_right">
        Reportes
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-for="checkbox in checklist">
          <template v-if="isReports(checkbox)">
            <v-checkbox
              class="ma-0"
              hide-details
              :key="checkbox.id"
              v-model="checkbox.value"
              :label="checkbox.title"
            ></v-checkbox>
          </template>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel :key="5">
      <v-expansion-panel-header expand-icon="arrow_right">
        Proyecto Carrusel
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-for="checkbox in checklist">
          <template v-if="isCarousel(checkbox)">
            <v-checkbox
              class="ma-0"
              hide-details
              :key="checkbox.id"
              v-model="checkbox.value"
              :label="checkbox.title"
            ></v-checkbox>
          </template>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("user/register", ["checklist"])
  },
  methods: {
    isDynamicBoard(checkbox) {
      if (checkbox.section === "dynamicBoard") return true;
    },
    isDamage(checkbox, readOrEdit) {
      if (checkbox.section === "damage") {
        if (checkbox.subSection === readOrEdit) {
          return true;
        }
      }
    },
    isIndicators(checkbox, section) {
      if (checkbox.section === "indicators") {
        if (checkbox.subSection === section) {
          return true;
        }
      }
    },
    isCreateUsers(checkbox) {
      if (checkbox.section === "createUsers") return true;
    },
    isReports(checkbox) {
      if (checkbox.section === "reports") return true;
    },
    disabledAll(checkbox) {
      if (checkbox.title == "Global") {
        if (checkbox.value == true) {
          return false;
        }
      } else {
        return true;
      }
    },
    isCarousel(checkbox) {
      if (checkbox.section === "carousel") return true;
    }
  }
};
</script>

<style></style>
